'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSites$002dView$0024$0024anon$002438 from "./presto.-Sites-View$$anon$38.js";
import * as $j_presto$002e$002dSites$002dView$0024$0024anon$002439 from "./presto.-Sites-View$$anon$39.js";
import * as $j_presto$002e$002dSites$002dView$0024$0024anon$002440 from "./presto.-Sites-View$$anon$40.js";
import * as $j_presto$002e$002dSites$002dView$0024$0024anon$002441 from "./presto.-Sites-View$$anon$41.js";
var $p;
/** @constructor */
function $c_Lpresto_SitesView$$anon$37(outer) {
  this.byg = null;
  this.bye = null;
  this.byf = false;
  this.byc = null;
  this.byd = false;
  this.byh = false;
  this.byi = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.byg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_SitesView$$anon$37 as $c_Lpresto_SitesView$$anon$37 };
$p = $c_Lpresto_SitesView$$anon$37.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SitesView$$anon$37;
/** @constructor */
function $h_Lpresto_SitesView$$anon$37() {
}
export { $h_Lpresto_SitesView$$anon$37 as $h_Lpresto_SitesView$$anon$37 };
$h_Lpresto_SitesView$$anon$37.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.byg;
});
$p.t = (function() {
  if ((!this.byf)) {
    this.bye = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("SitesByCredential", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("SitesByTfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("SitesByCredentialGroup", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.byf = true;
  }
  return this.bye;
});
$p.ad = (function() {
  if ((!this.byd)) {
    this.byc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dSites$002dView$0024$0024anon$002438.$c_Lpresto_SitesView$$anon$38(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dSites$002dView$0024$0024anon$002439.$c_Lpresto_SitesView$$anon$39(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dSites$002dView$0024$0024anon$002440.$c_Lpresto_SitesView$$anon$40(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.byd = true;
  }
  return this.byc;
});
$p.v = (function() {
  if ((!this.byi)) {
    this.byh = true;
    this.byi = true;
  }
  return this.byh;
});
$p.cDr = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dSites$002dView$0024$0024anon$002441.$c_Lpresto_SitesView$$anon$41().cM5(a), a);
});
$p.ab = (function(a) {
  return this.cDr(a);
});
var $d_Lpresto_SitesView$$anon$37 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SitesView$$anon$37, "presto.SitesView$$anon$37", ({
  S1: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_SitesView$$anon$37 as $d_Lpresto_SitesView$$anon$37 };
//# sourceMappingURL=presto.-Sites-View$$anon$37.js.map
